import React from "react";
import SafeHtml from "@/components/ui/SafeHtml";
import type { TextEditorData } from "@/types/acf";

type Props = {
  data: TextEditorData & { id?: string; hide?: boolean };
};

export default function TextEditor({ data }: Props) {
  if (!data || data.hide || !data.content) return null;

  // keep anchor without Section/Wrapper
  return (
    <div id={data.id} className="text-editor-layout content content-flow min-w-0">
      <SafeHtml content={data.content} />
    </div>
  );
}
